import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcCalendarcheck(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.75 1.875a.75.75 0 0 1 .75.75V4h7V2.625a.75.75 0 0 1 1.5 0V4h1.25A2.75 2.75 0 0 1 21 6.75v12.5A2.75 2.75 0 0 1 18.25 22H5.75A2.75 2.75 0 0 1 3 19.25V6.75A2.75 2.75 0 0 1 5.75 4H7V2.625a.75.75 0 0 1 .75-.75M19.5 6.75v1.5h-15v-1.5c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25m0 3h-15v9.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25zm-8.675 6.155 3.677-3.677a.75.75 0 0 1 .537-.228.73.73 0 0 1 .548.228.74.74 0 0 1 .232.542.74.74 0 0 1-.232.543l-4.13 4.128a.87.87 0 0 1-.632.271.87.87 0 0 1-.633-.27l-2.028-2.03a.75.75 0 0 1-.228-.537.73.73 0 0 1 .228-.547.74.74 0 0 1 .542-.233q.31 0 .542.233z",
    clipRule: "evenodd"
  }));
}
var IcCalendarcheck = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCalendarcheck));

export { IcCalendarcheck as I };
